// extracted by mini-css-extract-plugin
module.exports = {"content":"content_content__2NTol","inner_content":"content_inner_content__1dh0K","item_content":"content_item_content__1hwD7","min_article":"content_min_article__2QE6A"};